require('../../../scss/components/tombola.scss');
import rwxTombola from 'roseworx/js/components/rwxTombola';

// window.addEventListener('load', ()=>{
// 	setTimeout(()=>{
// 		rwxTombola.setConfig({stopText:"What one?", autoStop: false, timeBeforeAutoStop: 1});
// 	}, 2000);
// })

document.getElementById('setValuesDemo').addEventListener('click', ()=>{
	const val = document.getElementById('setValuesVal').value.split('\n');
	const selectedValue = document.getElementById('selectedValue');
	const vals = [];
	val.map((v)=>vals.push({value: v, displayName: v}));
  rwxTombola.setValues(vals)
  .then((res)=>{ selectedValue.innerText = `You got '${res}'` });
});